import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import modernizr from 'modernizr';
import { defineMessages, FormattedMessage } from 'react-intl';

import { contactShape } from './util';
import Contact from './contact';
import SelectedContact from './selected-contact';
import Segment from '../../components/Segment';
import Table from '../../components/Table';
import Container from '../../components/Container';
import Button from '../../components/Button';
import Loader from '../../components/Loader';

import './styles.css';

const messages = defineMessages({
  noResults: {
    id: 'repvisits.contacts.search.noResults',
    defaultMessage: 'Your search did not return any contacts.',
  },
  showMore: {
    id: 'repvisits.contacts.search.showMore',
    defaultMessage: 'Show More',
  },
});

export default class ContactsList extends React.PureComponent {
  static propTypes = {
    contacts: PropTypes.arrayOf(contactShape),
    hasNextPage: PropTypes.bool,
    loadMore: PropTypes.func.isRequired,
    changeRepVisitsContactNotes: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      selected: null,
      loading: false,
    };
  }

  loadMore = () => {
    this.setState({ loading: true });
    this.props.loadMore('viewer.repVisitsContacts').then(() => this.setState({ loading: false }));
  };

  selectContact = (contact) => {
    if (modernizr.mq('(max-width: 767px)')) {
      this.setState({ selected: contact });
    }
  };

  clearSelected = () => {
    this.setState({ selected: null });
  };

  render() {
    const { contacts, hasNextPage, changeRepVisitsContactNotes } = this.props;
    return (
      <Segment styleName="contacts-list">
        <Table basic="very" textAlign="left" unstackable data-cy="contacts-list">
          <Table.Body>
            {contacts.map((contact) =>
              (
                <Contact
                  key={get(contact.node.highSchool, 'id')}
                  contact={contact.node}
                  handleSelect={this.selectContact}
                  changeRepVisitsContactNotes={changeRepVisitsContactNotes}
                />
              ))}
          </Table.Body>
        </Table>
        <SelectedContact
          dismiss={this.clearSelected}
          contact={this.state.selected || {}}
          changeRepVisitsContactNotes={changeRepVisitsContactNotes}
        />
        {hasNextPage && (
        <Container textAlign="center">
          <Loader inline active={this.state.loading} />
          <Button size="small" primary onClick={this.loadMore}>
            <FormattedMessage {...messages.showMore} />
          </Button>
        </Container>
        )}
      </Segment>
    );
  }
}
